
export default function CategoryChildrenORG({ categoryChildren = [], type }) {
    return <div className="">

        {categoryChildren && categoryChildren.length > 0 ? categoryChildren.map((cc) => {
            return <div className="flex gap-2 mb-2">
                <a href={type == 1 ? `/ProductsCategoryDetail?${cc.id}` : `/PostsCategoryDetail?${cc.id}`}> <div className=" pr-1 font-normal text-gray-700 text-xs underline">
                    {cc.name}
                </div></a>
            </div>
        }) : null}

    </div>
}

